import { Component, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'email-input',
    imports: [
        FormsModule,
        MatInputModule,
        TranslateModule
    ],
    templateUrl: './email-input.component.html',
    styleUrl: './email-input.component.css'
})
export class EmailInputComponent {

  email = model<string>('');
  isValid = model<boolean>(false);

  validateEmail() {

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.isValid.set(
      re.test(
        this.email().toLowerCase()
      )
    );
  }

}
